// @flow

import { observer } from "mobx-react";
import * as React from "react";

import "./DropZone.scss";

type Props = {
    onDrop: Function,
    disabled: boolean,
    children: React.Node
};

@observer
export default class DropZone extends React.Component<Props> {
    element: ?HTMLElement;
    dragging: boolean;

    handleDrop(event: SyntheticInputEvent<HTMLDivElement>) {
        event.preventDefault();
        event.stopPropagation();

        this.cancelDragging();

        if (!this.props.disabled) {
            this.props.onDrop(event);
        }
    }

    handleDragOver(event: SyntheticInputEvent<HTMLDivElement>) {
        event.preventDefault();
        if (this.props.disabled) return;

        if (!this.element) return;
        const element: HTMLElement = this.element;

        this.dragging = true;

        if (element.className.indexOf("DropZone--dragging") === -1) {
            element.className += " DropZone--dragging";
        }
    }

    handleDragLeave(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        this.cancelDragging();
    }

    cancelDragging() {
        this.dragging = false;

        if (!this.element) return;
        const element: HTMLElement = this.element;

        let classes = element.className.split(" ");
        const index = classes.indexOf("DropZone--dragging");
        if (index !== -1) {
            classes.splice(index, 1);
        }

        element.className = classes.join(" ");
    }

    render() {
        const classes = ["DropZone"];
        if (this.dragging) classes.push("DropZone--dragging");

        return (
            <div
                className={classes}
                ref={el => (this.element = el)}
                onDrop={this.handleDrop.bind(this)}
                onDragOver={this.handleDragOver.bind(this)}
            >
                {this.props.children}

                <div
                    className="DropZone__overlay"
                    onDragLeave={this.handleDragLeave.bind(this)}
                >
                    Drop image
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/DropZone/DropZone.js